import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';

import { AdminChartInfoIcon, AdminCriticleChartInfoIcon, ChartInfoIcon, CriticleChartInfoIcon } from 'shared/icons/icon';
import PermissionManager, { checkPermission } from 'shared/hoc/permission/permissionManager';
import { adminPermissionMapping } from 'shared/constants/permissionConstant';

import AddInfoPopUp from './addInfoPopUp';
import { IChartDetails } from '../interface/futureTable';
import { State } from 'shared/interface';

interface IProps {
	chartDetails: IChartDetails;
	chartId: string;
}

const ChartInfo: React.FC<IProps> = (props) => {
	const { chartDetails, chartId } = props;
	const { language } = useSelector((state: State) => state.siteConfig);
	const [isAddInfo, setIsAddInfo] = useState(false);
	const [tooltipInfo, setTooltipInfo] = useState({
		info_de: chartDetails.info_de.trim(),
		info_en: chartDetails.info_en.trim()
	});
	const [priority, setPriority] = useState(chartDetails.priority);
	return (
		<Fragment>
			<span id={`${chartDetails.symbol}-${chartDetails.boerse}-${chartId}`} className='ml-6 height--fit-content'>
				{checkPermission({ permission: adminPermissionMapping.superDataAdmin }) ? (
					priority ? (
						<AdminCriticleChartInfoIcon onClick={() => setIsAddInfo(!isAddInfo)} height='26' width='30' className='cursor-pointer' />
					) : (
						<AdminChartInfoIcon onClick={() => setIsAddInfo(!isAddInfo)} height='26' width='30' className='cursor-pointer' />
					)
				) : priority ? (
					<CriticleChartInfoIcon height='26' width='30' className='cursor-pointer' />
				) : (
					<ChartInfoIcon height='26' width='30' className='cursor-pointer' />
				)}
				<Tooltip
					anchorId={`${chartDetails.symbol}-${chartDetails.boerse}-${chartId}`}
					place='bottom'
					className='no-padding chart-info--tooltip'
					content={language === 'en' ? tooltipInfo.info_en : tooltipInfo.info_de}
					clickable
				/>
			</span>

			{isAddInfo && (
				<PermissionManager permission={adminPermissionMapping.superDataAdmin}>
					<AddInfoPopUp
						isAddInfo={isAddInfo}
						handleClosePopup={() => setIsAddInfo(false)}
						submitParams={{
							boerse: chartDetails.boerse,
							basis_symbol: chartDetails.basis_symbol,
							symbol: chartDetails.symbol
						}}
						initialValues={{ info_de: tooltipInfo.info_de, info_en: tooltipInfo.info_en, priority: priority }}
						setTooltipInfo={setTooltipInfo}
						setPriority={setPriority}
					/>
				</PermissionManager>
			)}
		</Fragment>
	);
};

export default ChartInfo;
